import React from 'react';
import { useState } from 'react';
import { checkDataAPI } from './hook/API';
import background from "../../../assets/images/curved-6.jpg";
import { useTranslation } from 'react-i18next';
import { onChangeEmail, onChangePhone } from './hook/ScreenHelper';
import { store } from '../../../redux/store';
import { setErrorMsg } from '../../../redux/reducers/settingsSlice';
import { useNavigate } from 'react-router-dom';
import { Error, LogoSmall } from '../../../utils/Icons';

export const ForgetPassword: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('1');
    
    const buttonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        checkDataAPI({email, phone: '+966' + phone}, (success) => {
            if (success) { 
                navigate('/forget_password/verify', {state: {email,phone: '+966' + phone} })
            } else {
                store.dispatch(setErrorMsg({
                    icon: <Error />,
                    title: t('reset_password.errors.merchant_not_found'),
                    message: t('reset_password.errors.merchant_not_found_desc')
                }))
            }
        });
    };
    

    return (
        <section>
            <div className="page-header min-vh-100">
                <div className="container">
                <div className="row">
                    <div className="col-md-4">
                        <div className="oblique position-absolute top-0 h-100 d-md-block d-none me-n8" style={{ width: '30%' }}>
                            <div className="oblique-image bg-cover position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6" style={{ backgroundImage: `url(${background})` }}>
                            </div>
                            <img style={{width: '60%', margin: 'auto', position: 'absolute', inset: 0}} src={require('../../../assets/icons/logo-with-words.png')} alt="" />
                        </div>
                    </div>
                    <div className="col-md-8 d-flex flex-column mx-auto">
                        <div className="card card-plain mt-6">
                            <div className="card-header  d-flex justify-content-center d-md-none">
                                <LogoSmall width={"75%"} />
                            </div>
                            <div className="card-header pb-0 text-left bg-transparent">
                                <h3 className="fw-normal text-dark">{t("reset_password.title")}</h3>
                                <h6 className="fw-normal text-dark">{t("reset_password.description")}</h6>

                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6 d-flex flex-column ">
                                        <label>Email Address</label>
                                        <div className="mb-3 d-flex">
                                            <input type="text" className={"form-control " + (email.length === 0 ? 'is-invalid' : '')} placeholder="Email Address" onChange={e => onChangeEmail(e, setEmail)} />
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex flex-column ">
                                        <label>Mobile Number</label>
                                        <div className="mb-3 d-flex">
                                            <div className="form-control w-auto me-2 d-flex align-items-center">
                                                <img src={require('../../../assets/images/flag_sa.jpg')} className="navbar-brand-img h-75 me-2" alt="main_logo" />
                                                +966
                                            </div>
                                            <input type="text" className="form-control" placeholder="Mobile Number" onChange={e => onChangePhone(e, setPhone)} value={phone}/>
                                        </div>
                                    </div>
                                    <div className="text-center d-flex flex-column flex-md-row mt-4 justify-content-between">
                                        <a href="login" className="btn btn-secondary px-7 py-3">Go back</a>
                                        <button type="button" className="btn btn-warning px-7 py-3" disabled={phone.length < 9 || email.length <= 1} onClick={buttonHandler}>Continue</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
                </div>
            </div>
        </section>
    );
}

